import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { LogService } from '../../../../shared/services/log.service';
import { TypeAnn } from '../../../common/models/type.ann';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { BehaviorSubject } from 'rxjs';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { MapaAt } from '../../../../shared/models/component-messages/mapaAT/mapa_at';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import { ContenuPdf } from '../../../common/models/contenuPdf';


@Component({
  selector: 'app-attributionformmapa',
  templateUrl: './formmapa.component.html'
})
export class FormMAPA_ATComponent implements OnInit {

  private LOG: LogService = new LogService(FormMAPA_ATComponent);

  @Input() indexPage: number;
  @Input() disabled = true;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() form: FormGroup;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  @Input() formName: string;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;
  public ann = new TypeAnn();
  public createForm = false;
  private isLierAvisSelected :boolean=false;

  public steps = [5, 6, 7, 9, 10, 11, 12, 18, 19];
  public mapaAt = new MapaAt();
  public pages: number[];

  constructor(private formulaireServiceService: FormulaireServiceService, private spinner: SpinnerVisibilityService, private annonceurService: AnnonceurService, public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private canNavigateInStepperService: CanNavigateInStepperService, private avisDataTransferService:AvisDataTransferService, private stepperBuilderService: StepperBuilderService
  ) { }
  public ngOnInit() {
    this.pages = Array.from({ length: 7 }, (_, index) => index + 1);
    this.initForm();
  }

  private initForm() {
    this.isLierAvisSelected=this.canNavigateInStepperService.isCreerAvisLierSelected;
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string' && ! this.createForm) {
        this.ann = data.jsonSaisieFormulaire.ann;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4)
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        this.createForm = true;
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
        this.avisDataTransferService.setFormData(data);
        this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        this.avisDataTransferService.jsonCSV = data.jsonCSV;
        this.avisDataTransferService.contenuPdf = data.jsonPdf;
        this.spinner.hide();
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.MAPA_AT, JsonContentEnum.EMPTY, data).subscribe(formData => {
          this.createForm = true;
          this.annonceurService.annonceurBhs.next(formData.jsonSaisieFormulaire.annonceur);
          this.ann = formData.jsonSaisieFormulaire.ann;
					const fluxAllerPA: any = formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation=formData.refConsultation;
          this.avisDataTransferService.siret=formData.jsonSaisieFormulaire.ann.facturation.libelle.siret;
          this.avisDataTransferService.setFormData(formData);
          if (this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational && JSON.stringify(formData.jsonCSV).includes('{}')) {
            this.stepperBuilderService.prepareMapErrors(formData.jsonFieldsErrorsWarnings);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 1);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 2);
            this.stepperBuilderService.initFormLiePDF('assets/data/formPDF/lieForms/' + FormsEnum[FormsEnum.MAPA_AT] + '.json').subscribe(
              (json) => {
                this.avisDataTransferService.contenuPdf = new ContenuPdf();
                this.avisDataTransferService.contenuPdf.champs = json;
                this.stepperBuilderService.PDFAvisLiesSetted.next({json:json,formData:formData});
                return json;
              }
            );
          } else {
            this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.MAPA_AT] + '.json');
            this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.MAPA_AT] + '.json');
            this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.MAPA_AT] + '.json');
          }
          this.spinner.hide();
        });
      }
    });
  }

  getIsCheckValid(indexPage) {
    return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
  }

  public getUid(indexPage) {
    return '_STEP_ID_' + indexPage;
  }

  public getUidCommon(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn';
  }

  getIntitule(indexPage) {
    return this.formulaireServiceService.hasTranslation(
      this.mapaAt.step + indexPage
    )
      ? this.mapaAt.step + indexPage
      : this.mapaAt.commonStep + indexPage;
  }

  getContents(indexPage) {
    switch (indexPage) {
      case this.steps[0]:
        return [];
      case this.steps[1]:
        return [];
      case this.steps[2]:
        return [];
      case this.steps[3]:
        return [];
      case this.steps[4]:
        return [];
      case this.steps[5]:
        return [];
      case this.steps[6]:
        return [];
      case this.steps[7]:
        return [];
      case this.steps[8]:
        return [];
    }
  }


}
